import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=249c8b70&scoped=true"
import script from "./back-button.ts?vue&type=script&lang=ts&external"
export * from "./back-button.ts?vue&type=script&lang=ts&external"
import style0 from "./back-button.scss?vue&type=style&index=0&id=249c8b70&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249c8b70",
  null
  
)

export default component.exports